var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReseller1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 55 55",
    width: 55,
    height: 55,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.65 45.65C14.85 46.45 8.45 52.85 7.65 53.65C7.45 53.84 7.45 54.16 7.65 54.35C7.74 54.45 7.87 54.5 8 54.5C8.13 54.5 8.26 54.45 8.35 54.35C9.15 53.55 15.55 47.15 16.35 46.35C16.55 46.16 16.55 45.84 16.35 45.65C16.16 45.45 15.84 45.45 15.65 45.65Z",
    id: "a1hRKhk28R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35 47.35C2.15 46.55 8.55 40.15 9.35 39.35C9.55 39.16 9.55 38.84 9.35 38.65C9.16 38.45 8.84 38.45 8.65 38.65C7.85 39.45 1.45 45.85 0.65 46.65C0.45 46.84 0.45 47.16 0.65 47.35C0.74 47.45 0.87 47.5 1 47.5C1.13 47.5 1.26 47.45 1.35 47.35Z",
    id: "bssc09F6h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 44.65C8.75 45.55 1.55 52.75 0.65 53.65C0.45 53.84 0.45 54.16 0.65 54.35C0.74 54.45 0.87 54.5 1 54.5C1.13 54.5 1.26 54.45 1.35 54.35C2.25 53.45 9.45 46.25 10.35 45.35C10.55 45.16 10.55 44.84 10.35 44.65C10.16 44.45 9.84 44.45 9.65 44.65Z",
    id: "afxtbP981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.89 1C53.83 1 53.73 1 53.61 1C53.61 1 53.6 1 53.6 1C51.47 1 41.25 1.53 35 5C32.12 6.59 26.12 13.28 20.71 19.72C19.15 19.4 16.44 18.92 14.3 18.92C13.83 18.92 13.39 18.95 13 19C9.91 19.41 1 29 1 29C1.92 29.37 9.31 32.33 10.24 32.7C10.08 32.89 10 33 10 33C10 33 9.81 36.81 14 41C17.84 44.84 21.36 45 21.92 45C21.97 45 22 45 22 45C22 45 22.11 44.92 22.31 44.76C22.67 45.68 25.63 53.08 26 54C26 54 35.52 44.96 36 42C36.32 40.06 35.79 36.41 35.39 34.09C41.81 28.67 48.43 22.72 50 20C50.55 19.05 51.02 18 51.43 16.9C51.43 16.89 51.43 16.89 51.43 16.89C53.66 10.87 54 3.25 54 1.42C54 1.4 54 1.39 54 1.38C54 1.26 54 1.17 54 1.11C54 1.1 54 1.1 54 1.09C54 1.04 54 1 54 1C54 1 53.97 1 53.92 1C53.91 1 53.91 1 53.89 1ZM13.13 19.99C13.46 19.95 13.86 19.93 14.3 19.93C16.12 19.93 18.42 20.3 19.98 20.6C17.9 23.1 15.93 25.52 14.3 27.55C14.06 27.83 12.86 29.25 10.7 31.8L2.74 28.62C8.52 23.02 11.99 20.14 13.13 19.99ZM26.38 52.25C26.16 51.72 25.1 49.06 23.18 44.27C24.14 43.39 24.67 42.9 24.77 42.8C27.14 40.91 30.74 38.01 34.5 34.84C34.89 37.22 35.27 40.27 35.01 41.84C34.74 43.49 30.11 48.59 26.38 52.25ZM21.67 43.99C20.76 43.92 17.87 43.46 14.71 40.29C11.51 37.1 11.07 34.23 11.01 33.33C13.13 30.61 30.16 8.83 35.49 5.87C36.37 5.38 37.35 4.96 38.37 4.58C38.9 6.29 40.14 9.14 43 12C45.88 14.88 48.75 16.12 50.45 16.64C50.07 17.66 49.64 18.63 49.13 19.5C46.21 24.57 24.41 41.83 21.67 43.99ZM43.71 11.29C40.97 8.56 39.8 5.84 39.32 4.26C39.45 4.21 39.59 4.17 39.73 4.13C39.9 4.07 40.08 4.02 40.25 3.96C40.25 3.96 40.25 3.96 40.25 3.96C45.21 2.52 50.72 2.13 52.97 2.03C52.88 4.43 52.49 10.56 50.78 15.69C49.2 15.21 46.46 14.05 43.71 11.29Z",
    id: "bMD6wQuXP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.05 15.05C27.32 17.78 27.32 22.22 30.05 24.95C31.42 26.32 33.21 27 35 27C36.79 27 38.58 26.32 39.95 24.95C42.68 22.21 42.68 17.78 39.95 15.05C38.58 13.68 36.79 13 35 13C33.21 13 31.42 13.68 30.05 15.05ZM35 26C33.4 26 31.89 25.38 30.76 24.24C29.62 23.11 29 21.6 29 20C29 18.4 29.62 16.89 30.76 15.76C31.89 14.62 33.4 14 35 14C36.6 14 38.11 14.62 39.24 15.76C40.38 16.89 41 18.4 41 20C41 21.6 40.38 23.11 39.24 24.24C38.11 25.38 36.6 26 35 26Z",
    id: "eBZBHso5l"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1hRKhk28R",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1hRKhk28R",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bssc09F6h",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bssc09F6h",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afxtbP981",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afxtbP981",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bMD6wQuXP",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bMD6wQuXP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eBZBHso5l",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eBZBHso5l",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseller1);
export default __webpack_public_path__ + "static/media/reseller-1.c109e3aeae25218c7478b921e311cfc4.svg";
export { ForwardRef as ReactComponent };